import React from 'react';
import { observer } from 'mobx-react';
import {
    Grid,
    Box,
} from '@material-ui/core';

import {
    Typography,
} from '../../components/Wrappers/Wrappers.jsx';
import useUserPublisherInfo from '../../store/models/user/useUserPublisherInfo';
import EcalWorldProfileSwitch from './EcalWorldProfileSwitch';
import PhotoUpload from './PhotoUpload';
import useCoverPhoto from './useCoverPhoto';
import useEcalWorldAsDev from './useEcalWorldAsDev';
import { useStyles } from './styles';

function EcalWorld () {
    const { publisher } = useUserPublisherInfo();
    const classes = useStyles();
    const { devAccess } = useEcalWorldAsDev();

    const {
        coverPhoto,
        handleUpload,
        handleDelete,
        renderErrorDialog,
    } = useCoverPhoto();

    // Temporarily only allow developers to access this.
    if (!devAccess) {
        return null;
    }

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} justify={'center'} container>
                <Box
                    display={'flex'}
                    flexDirection={'column'}
                    width={600}
                    className={classes.boxStyling}
                >
                    <Typography
                        variant={'h5'}
                        weight={'medium'}
                        style={{ marginBottom: 30 }}
                    >
                        ECAL World Marketing
                    </Typography>

                    <EcalWorldProfileSwitch publisher={publisher} />

                    <PhotoUpload
                        title={'Your Cover Photo'}
                        imageSource={coverPhoto}
                        onUpload={handleUpload}
                        onDelete={handleDelete}
                    />
                </Box>
            </Grid>

            { renderErrorDialog() }
        </Grid>
    );
}

const ObservedEcalWorld = observer(EcalWorld);
export default ObservedEcalWorld;
